import Vue from 'vue'
import clone from 'clone'
import { QUOTE_PA_PARAM, QUOTE_PA_PARAM_GENERAL, QUOTE_PA_GENERAL, QUOTE_PA_PLANS, QUOTE_PA_PARAM_PLAN_LOADING, QUOTE_PA_PARAM_PLAN_SUCCESS, QUOTE_PA_PARAM_PLAN_FAIL, QUOTE_PA_APPLICANT, QUOTE_PA_INSURED_ADD, QUOTE_PA_INSURED_REMOVE, QUOTE_PA_INSURED_UPDATE, QUOTE_PA_PAYMENT, QUOTE_PA_ADJ_CANCEL, QUOTE_PA_RECALCULATE_LOADING, QUOTE_PA_RECALCULATE_SUCCESS, QUOTE_PA_RECALCULATE_FAIL, QUOTE_PA_OPT_CVRS } from '@/store/types'
import { commitPkgPremium } from './quote'
import { formatServerTimeFormat } from '@/utils/date'

export const pa = {
  [QUOTE_PA_PARAM](state, data) {
    // Note: Key - ignoreValue is reserved
    if (data) {
      const formatData = data
      let ignoreValue = data.ignoreValue
      if (ignoreValue === undefined) {
        ignoreValue = false
      }
      Object.keys(formatData).forEach(function (key) {
        if (key !== 'ignoreValue') {
          const arr = formatData[key]
          if (arr) {
            if (Array.isArray(arr)) {
              // Make it so that its value - label (easier to search)
              arr.map(obj => {
                if (!ignoreValue) {
                  obj.label = obj.value + ' - ' + obj.label
                }
              })
            }
            // Initially was using the Object.assign below
            // But due to vue js reactive caveats, we will use Vue.set instead
            Vue.set(state.quotation.paParam, key, arr)
          }
        }
      })
    }
  },
  [QUOTE_PA_PARAM_GENERAL](state) {
    state.quotation.paParam.generalLoaded = true
  },
  [QUOTE_PA_GENERAL](state, data) {
    if (data) {
      state.quotation.commonForm.product = data.product
      state.quotation.commonForm.acceptDate = data.acceptDate
      state.quotation.commonForm.startDate = data.startDate
      state.quotation.commonForm.endDate = data.endDate
      state.quotation.commonForm.campaign = data.campaign
      state.quotation.commonForm.promotion = data.promotion
      state.quotation.commonForm.scheme = data.scheme

      state.quotation.paForm.noAdult = data.noAdult
      state.quotation.paForm.noChild = data.noChild

      // Reset plans init (always get new plans after 1st screen)
      state.quotation.paParam.plans.init = 0
    }
  },
  [QUOTE_PA_PARAM_PLAN_LOADING](state) {
    state.quotation.paParam.plans.init = 0
    state.quotation.paParam.plans.initErr = []
    state.quotation.paParam.plans.limitsText = []
    state.quotation.paParam.plans.plans = []
  },
  [QUOTE_PA_PARAM_PLAN_SUCCESS](state, data) {
    state.quotation.paParam.plans.limitsText = data.limitsText
    state.quotation.paParam.plans.plans = data.plans
    state.quotation.paParam.plans.init = 1
    state.quotation.paParam.plans.initErr = []
    state.quotation.paParam.optCvrs = data.optCvrs
  },
  [QUOTE_PA_PARAM_PLAN_FAIL](state, data) {
    state.quotation.paParam.plans.init = 2
    state.quotation.paParam.plans.limitsText = []
    state.quotation.paParam.plans.plans = []
    state.quotation.paParam.plans.initErr = []
    if (data && data.length > 0) {
      state.quotation.paParam.plans.initErr = data
    }
  },
  [QUOTE_PA_OPT_CVRS](state, data) {
    const { commonForm } = state.quotation
    const optCvrs = []
    if (data.optCvrs) {
      for (let optCvr of data.optCvrs) {
        let keys = optCvr.split('-')
        let riskNo = keys[0]
        let itemNo = keys[1]
        let type = keys[2]
        optCvrs.push({
          riskNo: riskNo,
          itemNo: itemNo,
          paType: type,
          si: 0
        })
      }
    }
    if (data.optCvrSI) {
      for (let optCvr in data.optCvrSI) {
        let keys = optCvr.split('-')
        let riskNo = keys[0]
        let itemNo = keys[1]
        let type = keys[2]
        let si = data.optCvrSI[optCvr]
        if (si === 0) {
          continue
        }
        optCvrs.push({
          riskNo: riskNo,
          itemNo: itemNo,
          paType: type,
          si: si
        })
      }
    }
    commonForm.optCvr = optCvrs
  },
  [QUOTE_PA_PLANS](state, data) {
    if (data) {
      state.quotation.paForm.planNo = data.planNo
      state.quotation.paForm.paType = data.paType

      // Save premium info to commonInfo
      const plan = state.quotation.paParam.plans.plans.find(x => x.planNo === data.planNo && x.subPlan === data.paType)
      if (plan && plan.premium) {
        state.quotation.commonForm.scheme = plan.scheme
        state.quotation.commonForm.schemeDesc = plan.schemeDesc
        commitPkgPremium(state, plan.premium)

        // Flag reviewPlan init as 1 (as it wont trigger recalculate when coming back from the next page)
        state.quotation.paParam.reviewPlan.init = 1
      } else {
        commitPkgPremium(state, null)
      }
    } else {
      state.quotation.paForm.planNo = null
      state.quotation.paForm.paType = null
      commitPkgPremium(state, null)
    }
  },
  [QUOTE_PA_APPLICANT](state, data) {
    if (data) {
      // Applicant Information
      const { applicant } = state.quotation.commonForm

      applicant.appNationality = data.appNationality
      applicant.appMaritalStatus = data.appMaritalStatus
      applicant.appOccupation = data.appOccupation
      applicant.appName = data.appName
      applicant.appNricPassport = data.appNricPassport
      if (data.appDob) {
        applicant.appDob = formatServerTimeFormat(data.appDob)
      }
      applicant.appGender = data.appGender
      applicant.appIsInsured = data.appIsInsured
      applicant.appEmail = data.appEmail
      applicant.appMobileNo = data.appMobileNo
      applicant.appTelNo1 = data.appTelNo1
      applicant.appTelNo2 = data.appTelNo2
      applicant.appPostalCode = data.appPostalCode
      applicant.appAdd1 = data.appAdd1
      applicant.appAdd2 = data.appAdd2
      applicant.appAdd3 = data.appAdd3
      applicant.appAdd4 = data.appAdd4
      applicant.appRelationship = data.appRelationship

      const { paForm } = state.quotation
      // Remove applicant if it exist in insureds
      const mainInsured = paForm.insureds.find(x => x.isApplicant === true)
      if (mainInsured) {
        paForm.insureds.splice(paForm.insureds.indexOf(mainInsured), 1)
      }
      if (data.appIsInsured) {
        // Clone applicant to insured (if it has full data)
        if (data.appName && data.appNricPassport && data.appDob && data.appGender) {
          paForm.insureds.unshift({
            name: data.appName,
            nationality: data.appNationality,
            nricPassport: data.appNricPassport,
            dob: applicant.appDob,
            gender: data.appGender,
            occupation: data.appOccupation,
            maritalStatus: data.appMaritalStatus,
            relationship: data.appRelationship,
            isApplicant: true
          })
        }
      }
    }
  },
  [QUOTE_PA_INSURED_ADD](state, data) {
    if (data) {
      const cloneInsured = clone(data)
      if (cloneInsured.dob) {
        cloneInsured.dob = formatServerTimeFormat(cloneInsured.dob)
      }
      state.quotation.paForm.insureds.push(cloneInsured)
    }
  },
  [QUOTE_PA_INSURED_REMOVE](state, index) {
    state.quotation.paForm.insureds.splice(index, 1)
  },
  [QUOTE_PA_INSURED_UPDATE](state, data) {
    if (data) {
      const { index, insured } = data
      Vue.set(state.quotation.paForm.insureds, index, clone(insured))
    }
  },
  [QUOTE_PA_PAYMENT](state, data) {
    state.quotation.commonForm.paytMode = data.paytMode
    state.quotation.commonForm.paytCCNo = data.paytCCNo
    state.quotation.commonForm.paytCCName = data.paytCCName
    state.quotation.commonForm.paytCCType = data.paytCCType
    state.quotation.commonForm.paytCCExpMth = data.paytCCExpMth
    state.quotation.commonForm.paytCCExpYr = data.paytCCExpYr
    state.quotation.commonForm.paytCCCvv = data.paytCCCvv
  },
  [QUOTE_PA_ADJ_CANCEL](state) {
    // Reset Plan
    state.quotation.paForm.planNo = null

    // Reset Adjustment
    state.quotation.commonForm.adjDiscount = null

    // Reset Premium
    commitPkgPremium(state, null)
  },
  [QUOTE_PA_RECALCULATE_LOADING](state) {
    state.quotation.paParam.reviewPlan.init = 0
    state.quotation.paParam.reviewPlan.initErr = []
  },
  [QUOTE_PA_RECALCULATE_SUCCESS](state, data) {
    state.quotation.paParam.reviewPlan.init = 1
    state.quotation.paParam.reviewPlan.initErr = []
    commitPkgPremium(state, data)
  },
  [QUOTE_PA_RECALCULATE_FAIL](state, data) {
    state.quotation.paParam.reviewPlan.init = 2
    if (data && data.length > 0) {
      state.quotation.paParam.reviewPlan.initErr = data
    }
    // Reset Premium
    commitPkgPremium(state, null)
  }
}
